import { camelizeKeys } from "humps";
import { equals } from "ramda";
import { TrackJS } from "trackjs";
import { ORDERS_URL, STORE_BUCKET } from "api_urls";
import { getPrettyUrl, getPreviewToken } from "get_base_uri";
import {
  checkStatus,
  cloudfrontGetRequest,
  parseJSON,
  postRequest,
} from "helpers/ajax_request";
import getEnv from "helpers/get_env";

import oloStoreInfoTransform from "helpers/transforms/online_ordering/olo_store_info_transform";

function getOLOStoreInfo(callback) {
  return fetch(
    `${STORE_BUCKET}/${getPrettyUrl()}/online_ordering.json`,
    cloudfrontGetRequest()
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys)
    .then(oloStoreInfoTransform)
    .then(storeInfo => {
      if (callback) callback(storeInfo);
      return storeInfo;
    })
    .catch(error => {
      // if we aren't getting a brand back it either
      // doesn't exist or AWS is down
      TrackJS.track(error);
      if (equals(getEnv(), "production")) {
        window.location.href = "http://upserve.com";
      }
    });
}

function publishStore() {
  return fetch(
    `${ORDERS_URL}/${getPrettyUrl()}/publish`,
    postRequest({
      preview_token: getPreviewToken(),
    })
  ).then(checkStatus);
}

export default getOLOStoreInfo;

export { publishStore };
